import gql from 'graphql-tag';

const getAccountMarketingMaterialAssetDownloadUrls = gql`
  query accountMarketingMaterialAssetDownloadUrls($id: RecordID!) {
    accountMarketingMaterial(id: $id) {
      id
      type
      pdf_url
      pdf_download_url
      image_url
      image_download_url
    }
  }
`;

export default getAccountMarketingMaterialAssetDownloadUrls;
